import styled from "styled-components";

export const Container = styled.button`
  align-items: center;
  background-color: #fa821f;
  border-radius: 15px 15px 0 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 225px;
  margin: 25px auto;
  padding-top: 25px;
  width: 250px;
  p {
    align-items: center;
    background-color: #666;
    display: flex;
    justify-content: center;
    font-weight: bold;
    font-size: 18px;
    height: 40px;
    width: 100%;
  }
  img {
    width: 90%;
  }
`;
